const status = [
  {label: 'Pendente', original: 'pendent'},
  {label: 'Aprovado', original: 'approved'},
  {label: 'Reprovado', original: 'rejected'},
]

export default status;